import { useParams, Navigate } from 'react-router-dom'

// The old standalone document repository lives at /projects/:id/documents;
// documents now live in the project's Documents tab — send old links there.
export default function RedirectToDocumentsTab() {
  const { id } = useParams()
  return <Navigate to={`/projects/${id}?tab=documents`} replace />
}
